import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { CoinLogInterface } from '../../store/callrecorder/coinLogsSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.coinLogPath(value.id)
  };
}

export const coinLogsEntity = new schema.Entity(
  'coinLogs',
  {},
  {
    processStrategy
  }
);

export const coinLogEntity = new schema.Entity(
  'coinLog',
  {},
  {
    processStrategy
  }
);

const fetchCoinLogsCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      coinLogs: { [key: string]: CoinLogInterface };
    }
  >(response.data.coin_logs, [coinLogsEntity]);

  return {
    coinLogs: normalized.entities?.coinLogs || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { coinLog: CoinLogInterface; }
  >(response.data.coin_log, coinLogEntity);
  return normalized.entities;
}

export const fetchCoinLogs = createAsyncThunk(
  `${PREFIX}_coinLogs/fetchCoinLogs`,
  async (params: object = {}) => fetchCoinLogsCollection('/onesky/coin_logs', params)
);

export const fetchCoinLog = createAsyncThunk(
  `${PREFIX}_coinLogs/fetchCoinLog`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/coin_logs/${id}`);
    return normalizeInstance(response);
  }
);
